import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { configureAmplifyAuth } from './app/core/authentication/cognito-config';
import { environment } from './environments/environment';

configureAmplifyAuth(environment.cognito);

bootstrapApplication(App, appConfig)
  .catch(() => console.error('No fue posible iniciar la aplicación.'));
